module.exports = __webpack_public_path__ + "media/evolve/assets/icons/floorplans/zoom-out-simple-3e57cda6ec0f6b32e99463925fc053af.svg";